// removed by extract-text-webpack-plugin
module.exports = {"UserGeneratedText__warning":"UserGeneratedText__warning","userGeneratedTextWarning":"UserGeneratedText__warning","UserGeneratedTextHighlighter":"UserGeneratedTextHighlighter","userGeneratedTextHighlighter":"UserGeneratedTextHighlighter","UserGeneratedText":"UserGeneratedText","userGeneratedText":"UserGeneratedText"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/UserGeneratedTextContainer.scss
// module id = 419
// module chunks = 0